import React, { useState, useEffect } from "react";
import VideoPlayer from "./VideoPlayer";
import VideoSlider from "./VideoSlider";
import { VideoType } from "../../types";
import "../Video/styles.scss";

const Video: React.FC<VideoType> = ({ playList, script,bg_image,mobilebbackground, title, titleColor, section_class, showDescriptions, descriptionFontColor, backgroundColor, paragraphId }) => {
  const [current, setCurrent] = useState(0);
  const [dirty, setDirty] = useState(false);
  const [playerProps, setPlayerProps] = useState<any>({});
  // Validate flag value from showDescriptions.
  let hasShowDescriptions = Boolean(showDescriptions);

  useEffect(() => {
    if (current >= 0 && playList && playList.length) {
      const startIndex = 0;
      setCurrent(current);

      const curr = playList[current];
      setPlayerProps({
        url: curr.url,
        image: curr.image,
        title: curr.title,
      });
    }
  }, [playList, current]);

  const onFinishVideo = () => {
    if (current >= 0 && playList && playList.length) {
      setDirty(true);
      setCurrent(current + 1);

      const curr = playList[current + 1];
      setPlayerProps({
        url: curr.url,
        image: curr.image,
        title: curr.title,
      });
    }
  };
  titleColor = titleColor ? titleColor : '#000';
  return (
    <div id={'video-player-' + paragraphId} className={[section_class, "video-player"].join(' ')}>
      <img className="bg-img" src={bg_image}></img>
      <div className="inner-player">
        <style>
          {backgroundColor ? `
          #video-player-${paragraphId} {
            background-color: ${backgroundColor};
          }
          `: null
          }
          {descriptionFontColor ? `
         .jw-single-video .video-thumb-title {
            color: ${descriptionFontColor};
            font-size: 1rem;
          }
          `: null
          }
          {!hasShowDescriptions ? `
            .jw-single-video .video-thumb-title {
              display: none !important;
            }
            `: null
          }
        </style>
        <h4 style={{color: titleColor}}>{title}</h4>
        {current > -1 ? (
          <VideoPlayer
            {...playerProps}
            autoPlay={dirty}
            script={script}
            id={`video_player_carousel`}
            onFinish={() => onFinishVideo()}
          />
        ) : null}
        {current > -1 ? (
          <VideoSlider
            playList={playList}
            onChange={(index) => {
              setCurrent(index);

              setDirty(true);
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Video;
